/* Oyunperest — vitrin etkileşimleri. Saf JS, bağımlılık yok. */

/* ---- Bekleme psikolojisi araçları ----
   opBusy(dugme): <0.8sn hiçbir gösterge (anında algısı bozulmaz);
   0.8sn'de sessiz halka; 5sn'de nabız + ekran okuyucu duyurusu.
   Dönen fonksiyon temizler. opAnnounce: görünmez aria-live bölgesi. */
window.opAnnounce = function (message) {
  var region = document.getElementById('op-live');
  if (!region) {
    region = document.createElement('div');
    region.id = 'op-live';
    region.className = 'op-visually-hidden';
    region.setAttribute('aria-live', 'polite');
    document.body.appendChild(region);
  }
  region.textContent = message;
};

window.opBusy = function (button) {
  button.style.minWidth = button.getBoundingClientRect().width + 'px'; /* kesirli genişlik korunur — 0.5px büyüme olmaz */
  var ring = setTimeout(function () {
    button.classList.add('op-busy');
  }, 800);
  var long = setTimeout(function () {
    button.classList.add('op-busy--long');
    window.opAnnounce(button.getAttribute('data-op-slow') || 'İşlem sürüyor, bağlantı yavaş olabilir.');
  }, 5000);
  return function done() {
    clearTimeout(ring);
    clearTimeout(long);
    button.classList.remove('op-busy', 'op-busy--long');
    /* minWidth burada sıfırlanmaz: '✓' gibi kısa durum metinlerinde düğme
       büzülmesin — çağıran, son duruma dönerken opRelease ile temizler. */
  };
};

window.opRelease = function (button) {
  button.style.minWidth = '';
};

/* Geri/ileri önbelleğinden (bfcache) dönüşte sayfa, gönderim anındaki
   haliyle canlanır — takılı halka ve kilitli genişlik temizlenir. */
window.addEventListener('pageshow', function (event) {
  if (!event.persisted) return;
  document.querySelectorAll('.op-busy, .op-busy--long').forEach(function (el) {
    el.classList.remove('op-busy', 'op-busy--long');
    el.style.minWidth = '';
    if ('disabled' in el) el.disabled = false;
  });
});

/* 15 sn'de takılan istek hataya düşer — sonsuz dönen halka çaresizlik hissettirir */
window.opTimeout = function (promise, ms) {
  return Promise.race([
    promise,
    new Promise(function (ignore, reject) {
      setTimeout(function () { reject(new Error('timeout')); }, ms || 15000);
    }),
  ]);
};

/* ---- Sepete ekleme hatası: neden görünür olsun ----
   opAddResponse: /cart/add.js yanıtını çözer. Shopify 422 ile ziyaretçiye dönük
   kendi cümlesini gönderir ("Sepetinizde zaten bu üründen maksimum miktarda
   bulunuyor."); o cümle hatanın reason alanına taşınır. Başlığı "Cart Error" olan
   yanıtların açıklaması İngilizce ve tekniktir ("Cannot find variant"),
   ziyaretçiye gösterilmez.
   opCartError: nedeni ekran okuyucuya duyurur ve belgeye 'op:cart-error' olayı
   yayar; detail = { message, reason, status, button }. message her zaman dolu
   (neden yoksa genel cümle), reason yalnız Shopify'ın kendi cümlesidir.
   Görünür bildirimi renk-sahnesi.js gösterir. Hatayı kendi yerinde gösteren
   bölüm olayda preventDefault() çağırır; bildirim o zaman çıkmaz. */
window.opAddResponse = function (response) {
  if (response.ok) return response.json();
  return response
    .json()
    .catch(function () { return null; })
    .then(function (data) {
      var error = new Error('add-failed');
      error.status = response.status;
      error.reason = '';
      if (response.status === 422 && data && data.message !== 'Cart Error') {
        var text = typeof data.description === 'string' && data.description ? data.description : data.message;
        if (typeof text === 'string') error.reason = text.replace(/\s+/g, ' ').trim().slice(0, 240);
      }
      throw error;
    });
};

/* Mağazanın kök adresi ("/" ya da dil/pazar öneki "/en/"): sepet adresleri hep
   buna eklenir ki ikinci bir yerel ayar açılınca bazı yollar bozulmasın. */
window.opCartRoot = function () {
  return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
};

window.opCartError = function (button, error) {
  var reason = (error && error.reason) || '';
  var message = reason || 'Sepete eklenemedi. Lütfen tekrar deneyin.';
  window.opAnnounce(message);
  document.dispatchEvent(
    new CustomEvent('op:cart-error', {
      cancelable: true,
      detail: { message: message, reason: reason, status: (error && error.status) || 0, button: button || null },
    })
  );
  return message;
};

(function () {
  'use strict';

  /* ---- Mega menü: dışarı tıklayınca ve Escape ile kapanır ---- */
  function closeAllDetails(except) {
    document.querySelectorAll('details[data-op-details][open]').forEach(function (el) {
      if (el !== except) el.removeAttribute('open');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var inside = target instanceof Node ? target.closest('details[data-op-details]') : null;
    closeAllDetails(inside);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('details[data-op-details][open]');
    if (open) {
      open.removeAttribute('open');
      var summary = open.querySelector('summary');
      if (summary) summary.focus();
    }
  });

  /* ---- Mobil çekmece: başlığın altında açılan akordeon ---- */
  document.addEventListener('click', function (event) {
    var toggle = event.target instanceof Node ? event.target.closest('[data-op-drawer-toggle]') : null;
    if (!toggle) return;

    var drawer = document.getElementById(toggle.getAttribute('aria-controls') || 'op-drawer');
    if (!drawer) return;

    var isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!isOpen));
    drawer.toggleAttribute('hidden', isOpen);
  });

  /* ---- Sepet sayacı: sepete ekleme sonrası tazelenir ----
     Tek /cart.js isteği atılır; sonuç 'op:cart' olayıyla (detail.cart) yayılır ki
     başka betikler (ör. rs-finder.js) aynı sepeti ikinci kez çekmesin.
     Sepet sayfasında istek hiç atılmaz: rs-cart.js zaten bölüm HTML'ini tazeler
     ve sayacı oradaki data-item-count ile günceller. */
  function refreshCartCount() {
    if (document.querySelector('[data-rs-cart]')) return;
    fetch(window.opCartRoot() + 'cart.js', {
      headers: { Accept: 'application/json' },
    })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (!cart) return;
        document.dispatchEvent(new CustomEvent('op:cart', { detail: { cart: cart } }));
        document.querySelectorAll('[data-op-cart-count]').forEach(function (el) {
          var changed = el.textContent !== String(cart.item_count);
          el.textContent = String(cart.item_count);
          if (changed) {
            el.classList.remove('op-bump');
            void el.offsetWidth; /* animasyonu yeniden tetikle */
            el.classList.add('op-bump');
          }
        });
      })
      .catch(function () {
        /* sessiz geç — sayaç bir sonraki sayfa yüklemesinde düzelir */
      });
  }

  document.addEventListener('op:cart-updated', refreshCartCount);

  /* ---- Ajax sepete ekleme ---- */
  document.addEventListener('click', function (event) {
    var button = event.target instanceof Node ? event.target.closest('[data-op-add]') : null;
    if (!button) return;

    var variantId = button.getAttribute('data-op-add');
    if (!variantId) return;

    event.preventDefault();

    var original = button.getAttribute('data-op-label') || button.textContent;
    button.setAttribute('data-op-label', original);
    button.disabled = true;
    var settle = window.opBusy(button);

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };

    window.opTimeout(
      fetch(window.opCartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
    )
      .then(window.opAddResponse)
      .then(function () {
        settle();
        button.textContent = button.getAttribute('data-op-added') || '✓';
        window.opAnnounce(button.getAttribute('data-op-added-announce') || 'Ürün sepete eklendi.');
        /* Sayaç 'op:cart-updated' dinleyicisinden tazelenir (yukarıda); burada ayrıca çağrılmaz */
        document.dispatchEvent(new CustomEvent('op:cart-updated'));
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
          window.opRelease(button);
        }, 1600);
      })
      .catch(function (error) {
        settle();
        button.textContent = button.getAttribute('data-op-error') || original;
        window.opCartError(button, error);
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
          window.opRelease(button);
        }, 2400);
      });
  });
})();

/* ---- Koleksiyon ve arama: sıralama formu ve "daha fazla yükle" ---- */
(function () {
  'use strict';

  /* Sıralama seçimi anında uygulanır; JS yoksa formun kendi
     gönder butonu (noscript) devreye girer. */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof Node)) return;

    var form = input.closest('[data-op-sort-form]');
    if (!form) return;

    var params = new URLSearchParams(new FormData(form));
    // Boş alanlar adres çubuğunu kirletmesin
    Array.from(params.keys()).forEach(function (key) {
      if (!params.get(key)) params.delete(key);
    });

    var query = params.toString();
    window.location.href = form.getAttribute('action') + (query ? '?' + query : '');
  });

  /* Daha fazla yükle — sonraki sayfayı getirip ızgaraya ekler.
     Bağlantı olduğu için JS çalışmazsa sayfa normal şekilde açılır. */
  /* İskelet kartlar: bekleme boş ekran değil, dolmakta olan raf gibi görünür.
     0.8sn altı yüklemelerde iskeletler zaten göz kırpmadan yerini bulur. */
  function appendSkeletons(grid, howMany) {
    var frag = document.createDocumentFragment();
    var items = [];
    for (var i = 0; i < howMany; i += 1) {
      var card = document.createElement('div');
      card.className = 'op-skel';
      card.setAttribute('aria-hidden', 'true');
      card.innerHTML = '<div class="op-skel__media"></div><div class="op-skel__line"></div><div class="op-skel__line op-skel__line--short"></div>';
      frag.appendChild(card);
      items.push(card);
    }
    grid.appendChild(frag);
    return function removeSkeletons() {
      items.forEach(function (el) { el.remove(); });
    };
  }

  document.addEventListener('click', function (event) {
    var link = event.target instanceof Node ? event.target.closest('[data-op-load-more]') : null;
    if (!link) return;

    event.preventDefault();
    var settle = window.opBusy(link);
    var grid = document.querySelector('[data-op-grid]');
    var clearSkeletons = grid ? appendSkeletons(grid, 4) : function () {};

    window.opTimeout(fetch(link.href))
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(new Error('load-failed'));
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = parsed.querySelector('[data-op-grid]');
        if (!nextGrid || !grid) throw new Error('missing-grid');

        clearSkeletons();
        settle();
        window.opRelease(link);

        var added = 0;
        Array.from(nextGrid.children).forEach(function (child) {
          grid.appendChild(child);
          added += 1;
        });
        window.opAnnounce(added + ' kitap daha yüklendi.');

        var nextFooter = parsed.querySelector('.op-collection__more');
        var footer = document.querySelector('.op-collection__more');
        if (footer) {
          if (nextFooter) footer.replaceWith(nextFooter);
          else footer.remove();
        }
      })
      .catch(function () {
        clearSkeletons();
        settle();
        window.location.href = link.href;
      });
  });
})();

/* ---- Tam sayfa gönderimlerde bekleme dili ----
   Ürün formu ve bülten native gönderilir (sayfa değişir); o ana kadar
   düğme kademeli göstergeye geçer — çift tıklama ve tereddüt önlenir. */
(function () {
  'use strict';

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (event.defaultPrevented) return;

    var wantsBusy =
      form.matches('[data-op-product-form]') ||
      form.closest('.op-footer__form-wrap') !== null ||
      form.matches('.op-contact__form');
    if (!wantsBusy) return;

    /* İkinci dokunuş: gönderim zaten yolda. Yavaş mobil ağda tepki görmeyen
       ziyaretçi tekrar basınca sepete iki adet girmesin. */
    if (form.hasAttribute('data-op-submitted')) {
      event.preventDefault();
      return;
    }
    form.setAttribute('data-op-submitted', '');

    /* Basılan düğme: ürün sayfasında çoğu zaman form dışındaki sabit çubuk
       düğmesidir (form="rs-product-form"); halka ona takılır. */
    var button = event.submitter || form.querySelector('button[type="submit"], input[type="submit"]');
    if (button) {
      window.opBusy(button);
      /* Senkron disabled gönderilen veriden düğmenin name/value'sunu düşürür;
         bir sonraki adımda kapatılır */
      setTimeout(function () {
        button.disabled = true;
        button.setAttribute('data-op-locked', '');
      }, 0);
    }

    /* Sayfa 15 sn'de değişmediyse (takılan istek) kilit kalkar, yeniden denenebilir */
    setTimeout(function () { unlock(form); }, 15000);
  });

  /* Yalnız burada kapatılan düğmeler açılır (tükenmiş ürünün kapalı düğmesine dokunulmaz) */
  function unlock(form) {
    form.removeAttribute('data-op-submitted');
    document.querySelectorAll('[data-op-locked]').forEach(function (button) {
      if (button.form !== form) return;
      button.removeAttribute('data-op-locked');
      button.disabled = false;
      button.classList.remove('op-busy', 'op-busy--long');
      button.style.minWidth = '';
    });
  }

  /* Geri tuşuyla (bfcache) dönüldüğünde form gönderim anındaki kilitli haliyle
     canlanır: kilit ve kapalı düğmeler açılır */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('form[data-op-submitted]').forEach(unlock);
  });
})();

/* ---- Hediye modu: seçimler sepete line item property olarak gider ---- */
(function () {
  'use strict';

  var root = null;

  function init() {
    root = document.querySelector('[data-op-gift]');
    if (!root) return;
    updateTotal();
    updateSibling();
    updateSubmit();
  }

  /* Adım soruları cevaplanana dek "sepete ekle" kapalı kalır; ipucu görünür.
     Cevaplanmamış radyolar zaten property olarak yazılmıyor — bu yalnız kapı. */
  function updateSubmit() {
    var button = root.querySelector('[data-op-gift-add]');
    if (!button) return;

    var ready = true;
    root.querySelectorAll('[data-op-gift-step]').forEach(function (step) {
      if (!step.querySelector('input[type="radio"]:checked')) ready = false;
    });

    button.disabled = !ready;
    var hint = root.querySelector('[data-op-gift-hint]');
    if (hint) hint.toggleAttribute('hidden', ready);
  }

  function updateTotal() {
    var tier = root.querySelector('[name="op-gift-tier"]:checked');
    var total = root.querySelector('[data-op-gift-total]');
    if (tier && total) total.textContent = tier.getAttribute('data-op-tier-price') || '';
  }

  /* Tarih alanı 2026-11-05 verir; sepette, ödemede ve sipariş kaydında okunan
     değer "5 Kasım 2026" olur. Tanınmayan biçim olduğu gibi kalır. */
  var AYLAR = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
  function readableDate(iso) {
    var hit = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso || '');
    if (!hit || !AYLAR[Number(hit[2]) - 1] || !Number(hit[3])) return iso || '';
    return Number(hit[3]) + ' ' + AYLAR[Number(hit[2]) - 1] + ' ' + hit[1];
  }

  function updateSibling() {
    var note = root.querySelector('[data-op-gift-sibling-note]');
    if (!note) return;
    var trigger = root.querySelector('[data-op-gift-sibling]:checked');
    note.toggleAttribute('hidden', !trigger);
  }

  document.addEventListener('change', function (event) {
    if (!root || !(event.target instanceof Node) || !root.contains(event.target)) return;
    updateTotal();
    updateSibling();
    updateSubmit();
  });

  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!(field instanceof Node) || !field.matches('[data-op-gift-message]')) return;

    var counter = root.querySelector('[data-op-gift-counter]');
    if (counter) counter.textContent = field.value.length + ' / 120';
  });

  document.addEventListener('click', function (event) {
    var button = event.target instanceof Node ? event.target.closest('[data-op-gift-add]') : null;
    if (!button || !root) return;

    var tier = root.querySelector('[name="op-gift-tier"]:checked');
    if (!tier) return;

    var properties = {};

    root.querySelectorAll('[data-op-gift-field]').forEach(function (field) {
      var key = field.getAttribute('data-op-gift-field');
      if (!key) return;
      if (field.type === 'radio' && !field.checked) return;
      if (field.type === 'checkbox' && !field.checked) return;

      var value = field.value;
      var iso = '';
      if (field.hasAttribute('data-op-gift-date-mode')) {
        var picker = root.querySelector('[data-op-gift-date]');
        iso = picker ? picker.value : '';
        value = readableDate(iso);
      }
      if (value) properties[key] = value;
      /* Sıralama ve otomasyon için ISO hali ayrıca, gizli alanda gider: "_" ile
         başlayan alanları sepet ve ödeme sayfası göstermez, sipariş kaydında durur. */
      if (iso && value !== iso) properties._gonderim_tarihi = iso;
    });

    var message = root.querySelector('[data-op-gift-message]');
    if (message && message.value.trim()) {
      properties[message.getAttribute('data-op-gift-property')] = message.value.trim();
    }
    /* Hediye paketi tema ayarıyla açılır (settings.op_gift_wrap); kapalıyken düğmede anahtar yoktur */
    var wrapKey = button.getAttribute('data-op-gift-wrap-key');
    if (wrapKey) properties[wrapKey] = button.getAttribute('data-op-gift-wrap-value');

    var original = button.getAttribute('data-op-label') || button.textContent;
    button.disabled = true;
    var settle = window.opBusy(button);

    window.opTimeout(
      fetch(window.opCartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(tier.value), quantity: 1, properties: properties }] }),
      })
    )
      .then(window.opAddResponse)
      .then(function () {
        window.location.href = window.opCartRoot() + 'cart';
      })
      .catch(function (error) {
        settle();
        window.opRelease(button);
        button.disabled = false;
        button.textContent = button.getAttribute('data-op-error') || original;
        window.opCartError(button, error);
      });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* ---- "Birlikte alınır": birden çok ürünü tek istekte sepete ekler ---- */
document.addEventListener('click', function (event) {
  var button = event.target instanceof Node ? event.target.closest('[data-op-add-many]') : null;
  if (!button) return;

  var ids = (button.getAttribute('data-op-add-many') || '')
    .split(',')
    .map(function (v) { return Number(v.trim()); })
    .filter(Boolean);
  if (!ids.length) return;

  event.preventDefault();
  var original = button.getAttribute('data-op-label') || button.textContent;
  button.setAttribute('data-op-label', original);
  button.disabled = true;
  var settle = window.opBusy(button);

  window.opTimeout(
    fetch(window.opCartRoot() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) }),
    })
  )
    .then(window.opAddResponse)
    .then(function () {
      settle();
      button.textContent = button.getAttribute('data-op-added') || '✓';
      window.opAnnounce('Ürünler sepete eklendi.');
      document.dispatchEvent(new CustomEvent('op:cart-updated'));
      setTimeout(function () {
        button.textContent = original;
        button.disabled = false;
        window.opRelease(button);
      }, 1800);
    })
    .catch(function (error) {
      settle();
      button.textContent = button.getAttribute('data-op-error') || original;
      window.opCartError(button, error);
      setTimeout(function () {
        button.textContent = original;
        button.disabled = false;
        window.opRelease(button);
      }, 2400);
    });
});

/* ---- Canlı kargo geri sayımı ----
   "14.00'e kadar aynı gün kargo" yazan her satıra gerçek zamanlı kalan süre
   eklenir (İstanbul saati). Dürüst aciliyet: gerçek operasyon sınırı —
   pencere açıkken "son X sa Y dk", kapandıysa ve ertesi gün kargo günüyse
   "yarın kargoda" (pazar günü de: ertesi gün kargo var). Cumartesi ve ertesi günü
   kargosuz olan tatillerde sayaç hiç gösterilmez (işletme kararı, 19 Ekim 2026:
   kargonun günler sonra çıkacağı öne çıkarılmaz). Kargo verilmeyen günler:
   cumartesi, pazar ve sayfadaki data-op-ship-off niteliğinde virgülle yazılan
   tarihler (YYYY-AA-GG; sepet bölümünün "Kargo verilmeyen günler" ayarı).
   Kapalı durumda sayaca is-closed sınıfı eklenir: olumsuz bilgi vurgu rengiyle
   sunulmasın diye bölüm onu nötr yazar. JS yoksa statik metin aynen kalır.
   Eklenen yapı:
   <span class="op-countdown"><span class="op-countdown__sep"> · </span><span class="op-countdown__text">son 2 sa 10 dk</span></span> */
(function () {
  'use strict';

  var KESIM_DK = 14 * 60;
  var tatiller = {};

  function istanbulNow() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function (part) { map[part.type] = Number(part.value); });
    if (map.hour === 24) map.hour = 0;
    /* Takvim günü UTC'de tutulur: gün ekleme ve haftanın günü saat diliminden etkilenmez */
    map.date = new Date(Date.UTC(map.year, map.month - 1, map.day));
    return map;
  }

  function iso(date) {
    return date.toISOString().slice(0, 10);
  }

  function kargoGunu(date) {
    var gun = date.getUTCDay();
    return gun !== 0 && gun !== 6 && !tatiller[iso(date)];
  }

  function label() {
    var now = istanbulNow();
    var dakika = now.hour * 60 + now.minute;
    if (kargoGunu(now.date) && dakika < KESIM_DK) {
      var kalanDk = KESIM_DK - dakika;
      if (kalanDk < 60) return { open: true, text: 'son ' + kalanDk + ' dk' };
      var sa = Math.floor(kalanDk / 60);
      var dk = kalanDk % 60;
      return { open: true, text: 'son ' + sa + ' sa' + (dk > 0 ? ' ' + dk + ' dk' : '') };
    }
    /* Kapalıyken yalnız ertesi gün kargo günüyse söylenir */
    var next = new Date(now.date.getTime());
    next.setUTCDate(next.getUTCDate() + 1);
    if (kargoGunu(next)) return { open: false, text: 'şimdiki siparişler yarın kargoda' };
    return null;
  }

  function init() {
    document.querySelectorAll('[data-op-ship-off]').forEach(function (el) {
      (el.getAttribute('data-op-ship-off') || '').split(/[\s,;]+/).forEach(function (day) {
        if (/^\d{4}-\d{2}-\d{2}$/.test(day)) tatiller[day] = true;
      });
    });

    var hedefler = [];
    var selector = '.op-trust__row span';
    document.querySelectorAll(selector).forEach(function (el) {
      if (el.closest('.op-countdown') || el.querySelector('.op-countdown')) return;
      if (!/14[.:]00/.test(el.textContent)) return;
      /* Ayraç kendi öğesindedir: sayaç alt satıra inen yerlerde (sepet) satır
         başında nokta kalmasın diye o bölüm ayracı gizleyebilir (.op-countdown__sep). */
      var span = document.createElement('span');
      span.className = 'op-countdown';
      var sep = document.createElement('span');
      sep.className = 'op-countdown__sep';
      sep.setAttribute('aria-hidden', 'true');
      sep.textContent = ' · ';
      var metin = document.createElement('span');
      metin.className = 'op-countdown__text';
      span.appendChild(sep);
      span.appendChild(metin);
      el.appendChild(span);
      hedefler.push(span);
    });
    if (!hedefler.length) return;

    function tick() {
      var durum = label();
      hedefler.forEach(function (span) {
        span.hidden = !durum;
        if (!durum) return;
        span.classList.toggle('is-closed', !durum.open);
        span.lastChild.textContent = durum.text;
      });
    }
    tick();
    setInterval(tick, 30000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
